import React, { useState } from 'react';
import { DragDropContext } from 'react-beautiful-dnd';
import ProductVariationColumn from './ProductVariationColumn';
import GlobalVariationColumn from './GlobalVariationColumn';
import * as styles from './style';
import withCreateProductAddons from '../../containers/CreateProductsAddons';
import {
  VARIATION_DRAG_DROP_COLUMNS,
  PRODUCT_CREATION_VARIATION_TYPE,
  PRODUCT_VARIATION_ID_PREFIX,
} from '../../helpers/constants';
import withVariations from '../../containers/GlobalVariations';
import CreateVariationModal from '../../components/CreateVariationModal';
import Helper from '../../helpers/Helper';

const onDragEnd = (result, variations, addVariationItem, orderVariationItem) => {
  const { destination, source, draggableId } = result;

  if (!destination) return;

  const didNotMove =
    destination.droppableId === source.droppableId && destination.index === source.index;

  if (didNotMove) return;

  // Reordering
  if (source.droppableId === destination.droppableId) {
    orderVariationItem(draggableId, source.index, destination.index);
    return;
  }

  // Moving from one list to another
  const variation = variations.find(variation => variation.id === draggableId);
  addVariationItem(variation, destination.index, true);
};

const tempProductVariationId = (variations, globalVariations) => {
  let idList = [];
  if (variations.length) {
    idList = variations.map(variation => parseInt(variation.id.toString().replace(/\D/g, ''), 10));
  } else {
    idList = globalVariations.map(variation => variation.id);
  }

  let higherId = idList.length ? Helper.getHigherValueInArray(idList) : 0;

  return `${PRODUCT_VARIATION_ID_PREFIX}${higherId + 1}`;
};

const VariationDragDrop = ({
  variations,
  variationPersisted,
  productAddons,
  addVariationItem,
  orderVariationItem,
  isLoadingVariations,
  showEditVariantModal,
  editVariationItem,
  createVariation,
}) => {
  const [isDraggingOver, setIsDraggingOver] = useState(false);
  const [typeOfNewVariation, setTypeOfNewVariation] = useState(
    PRODUCT_CREATION_VARIATION_TYPE.global
  );

  const onSubmit = (formData, productVariation = false) => {
    if (productVariation || typeOfNewVariation === PRODUCT_CREATION_VARIATION_TYPE.product) {
      if (showEditVariantModal) {
        editVariationItem({
          ...variationPersisted,
          ...formData,
        });
      } else {
        formData.id = tempProductVariationId(productAddons.variations.list, variations);
        formData.isCreate = true;
        addVariationItem(formData, 0);
      }
    } else if (typeOfNewVariation === PRODUCT_CREATION_VARIATION_TYPE.global) {
      createVariation(formData);
    }
  };

  return (
    <DragDropContext
      onDragEnd={result => onDragEnd(result, variations, addVariationItem, orderVariationItem)}
    >
      <styles.Container>
        <ProductVariationColumn
          key={VARIATION_DRAG_DROP_COLUMNS.PRODUCT_VARIATIONS}
          isLoadingVariations={isLoadingVariations}
          items={productAddons.variations.list}
          setTypeOfNewVariation={setTypeOfNewVariation}
          setIsDraggingOver={setIsDraggingOver}
        />
        <GlobalVariationColumn
          key={VARIATION_DRAG_DROP_COLUMNS.GLOBAL_VARIATIONS}
          items={productAddons.variations.list}
          setTypeOfNewVariation={setTypeOfNewVariation}
          isDraggingOver={isDraggingOver}
        />

        <CreateVariationModal
          isProductVariation={typeOfNewVariation === PRODUCT_CREATION_VARIATION_TYPE.product}
          onSubmit={onSubmit}
        />
      </styles.Container>
    </DragDropContext>
  );
};

export default withVariations(withCreateProductAddons(VariationDragDrop));



// WEBPACK FOOTER //
// ./src/components/VariationDragDrop/index.js